// JavaScript para controlar el desplazamiento en el carrusel de categorías
const carouselContainer = document.querySelector('.category-carousel-container');
const arrowLeft = document.getElementById('arrow-left');
const arrowRight = document.getElementById('arrow-right');

// Función para calcular el ancho de cada ítem en base al contenedor
function getItemWidth() {
    return document.querySelector(".category-carousel-item").offsetWidth + 15; // Ancho de la imagen más el gap
}

// Evento para reiniciar el carrusel en dispositivos móviles
window.addEventListener('resize', function() {
    if (window.innerWidth <= 300) {
        carouselContainer.scrollLeft = 0; // Reajustamos el scroll a la primera imagen
    }
});

// Control de flechas
arrowLeft.addEventListener('click', () => {
    carouselContainer.scrollBy({
        left: -getItemWidth(), // Retrocede un ancho de item
        behavior: 'smooth'
    });
});

arrowRight.addEventListener('click', () => {
    carouselContainer.scrollBy({
        left: getItemWidth(), // Avanza un ancho de item
        behavior: 'smooth'
    });
});

// Asegurarse de que en móviles el carrusel comienza desde la primera imagen
if (window.innerWidth <= 767) {
    carouselContainer.scrollLeft = 0; // Esto asegura que cuando se cargue la página, empiece en la primera imagen
}
